import './date-input.scss'
import { ReactComponent as CalendarIcon } from 'assets/icons/calendar.svg'
import { useRef, useState } from 'react'
import Calendar from 'react-calendar'
import dayjs from 'dayjs'
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg'

const DateInput = ({
  value,
  label,
  onChange,
  name,
  isLocked,
  onUnlock,
  placeholder,
  disabled,
}) => {
  const clickRef = useRef((evt) => {
    if (evt.target.closest('.date-input') === null) {
      setIsOpen(false)
      document.removeEventListener('click', clickRef.current)
    }
  })
  const [isOpen, setIsOpen] = useState(false)
  const date = dayjs(value)

  const inputPlaceholder = isLocked ? 'mixed' : placeholder
  const inputDisabled = isLocked ? true : disabled
  const inputValue = value === null ? '' : value

  function handleOpenCalendar() {
    setIsOpen(true)
    document.addEventListener('click', clickRef.current)
  }

  function handleDateChange(date) {
    const newValue = dayjs(date).format('YYYY-MM-DD')
    const evt = {
      target: {
        name,
        value: newValue,
      },
    }

    onChange(evt)
    setIsOpen(false)
    document.removeEventListener('click', clickRef.current)
  }

  return (
    <div className="date-input">
      <label for={name}>{label}</label>
      <div className="input-container">
        <input
          type="text"
          value={inputValue}
          onChange={onChange}
          name={name}
          id={name}
          disabled={inputDisabled}
          placeholder={inputPlaceholder}
        />
        {isLocked ? (
          <div className="absolute top-0 right-0">
            <button
              className="bg-gray-light b-0 border-0 h-[37px] w-[35px] flex items-center justify-center rounded-r"
              onClick={onUnlock}
            >
              <EditIcon height="20" width="20" fill="#ccc" />
            </button>
          </div>
        ) : (
          <button
            onClick={handleOpenCalendar}
            className="ml-4 bg-gray-light px-2 rounded"
          >
            <CalendarIcon height="20" width="20" fill="#fefefe" />
          </button>
        )}

        {isOpen && (
          <div className="absolute top-10 z-[2]">
            <Calendar
              value={date.isValid() ? value : ''}
              onChange={handleDateChange}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default DateInput
